<script lang="ts" setup>
import BrandMapping from '@/helper/BrandMapping.ts'
import userStore from '@/store/UserStore.ts'
import { computed } from 'vue'

const getLogo = computed((): string => {
  const logoName = BrandMapping.getLogo(userStore.subBrand)
  return logoName ? `/static/img/logo-${logoName}.svg` : ''
})
</script>

<template>
  <footer class="footer">
    <div class="footer__wrapper">
      <div class="container footer__container">
        <nav class="footer__nav">
          <ul class="footer__list">
            <li v-if="userStore.globalLinks.imprint" class="footer__item">
              <a :href="userStore.globalLinks.imprint" class="link" target="_blank">{{ $t('global.imprint') }}</a>
            </li>
            <li v-if="userStore.globalLinks.dataProtection" class="footer__item">
              <a :href="userStore.globalLinks.dataProtection" class="link" target="_blank">
                {{ $t('global.dataProtection') }}
              </a>
            </li>
          </ul>
        </nav>
        <div class="footer__logo">
          <img v-if="getLogo" :src="getLogo" alt="logo">
        </div>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.footer {
  height: rem-calc($footerHeight);
  border-top: 1px solid #eee;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #ffffff;

  &__wrapper {
    margin-left: calc(100vw - 100%);
    height: 100%;
  }

  &__container {
    display: flex;
    height: 100%;
    align-items: center;
  }

  &__nav {
    margin-right: auto;
  }

  &__logo {
    margin-left: auto;

    img {
      width: rem-calc(100);
      height: auto;
    }
  }

  &__list {
    list-style: none;
    display: flex;
  }

  &__item {
    margin-right: rem-calc(56);

    a {
      text-decoration: none;
      color: $textColor;
      font-size: rem-calc(12);

      &:hover {
        text-decoration: underline;
        @include themify($themes) {
          color: themed('primaryColor');
        }
      }
    }
  }
}
</style>
